import React from 'react';
import './C2.css';

const C2: React.FC = () => {
  const cards = [
    { title: 'Mastery', subtitle: 'Native-level use', badge: 'C2', bg: '#5EEAD4' },
    { title: 'Precision', subtitle: 'Nuanced grammar', badge: 'C2', bg: '#3B82F6' },
    { title: 'Literature', subtitle: 'Analyze deeply', badge: 'C2', bg: '#EF4444' },
    { title: 'Presentations', subtitle: 'Speak professionally', badge: 'C2', bg: '#9333EA' },
  ];

  return (
    <div className="level-wrapper">
      <h1 className="level-title">C2 - Proficiency Level</h1>
      <div className="level-grid">
        {cards.map((card, index) => (
          <div key={index} className="level-card" style={{ backgroundColor: card.bg }}>
            <div className="level-badge">{card.badge}</div>
            <div className="level-content">
              <h2>{card.title}</h2>
              <p>{card.subtitle}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default C2;
